// extracted by mini-css-extract-plugin
export default {"remove":"remove_rf_ZxLiw","removeX":"removeX_rf_RDQ3v"};